module.exports = __webpack_public_path__ + "static/media/ic-usuarios-adicionados@3x.b53364ec.png";